const browsableMimeTypes = ['image/webp', 'image/jpeg', 'image/pjpeg', 'image/tiff', 'image/gif', 'image/png'];

export function isBrowsableImage(mime: string): boolean {
    return browsableMimeTypes.indexOf(mime) !== -1;
}
